import React from 'react';
import IntroServiceContainer from 'containers/IntroServiceContainer/IntroServiceContainer';

export default function IntroServicePage() {
    return (
        <IntroServiceContainer />
    )
}
